import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import Technicians from "./pages/Technicians";
import Orders from "./pages/Orders";
import Reports from "./pages/Reports";
import Leaves from "./pages/Leaves";
import Kasbon from "./pages/Kasbon";
import UangJalan from "./pages/UangJalan";
import PettyCash from "./pages/PettyCash";
import PettyCashMedan from "./pages/PettyCashMedan";
import TeamReimburse from "./pages/TeamReimburse";
import Payroll from "./pages/Payroll";
import Settings from "./pages/Settings";
import Expenses from "./pages/Expenses";
import Sosmed from "./pages/Sosmed";
import Pesan from "./pages/Pesan";
import Mileage from "./pages/Mileage";
import WhatsAppInbox from "./pages/WhatsAppInbox";
import WaShortcuts from "./pages/WaShortcuts";
import WaAiAgent from "./pages/WaAiAgent";
import FinanceReport from "./pages/FinanceReport";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
            <Route path="/technicians" element={<ProtectedRoute><Technicians /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/leaves" element={<ProtectedRoute><Leaves /></ProtectedRoute>} />
            <Route path="/kasbon" element={<ProtectedRoute><Kasbon /></ProtectedRoute>} />
            <Route path="/uang-jalan" element={<ProtectedRoute><UangJalan /></ProtectedRoute>} />
            <Route path="/petty-cash" element={<ProtectedRoute><PettyCash /></ProtectedRoute>} />
            <Route path="/reimbursement-tim" element={<ProtectedRoute><TeamReimburse /></ProtectedRoute>} />
            <Route path="/payroll" element={<ProtectedRoute><Payroll /></ProtectedRoute>} />
            <Route path="/laporan-keuangan" element={<ProtectedRoute><FinanceReport /></ProtectedRoute>} />
            <Route path="/petty-cash-medan" element={<ProtectedRoute><PettyCashMedan /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute><Expenses /></ProtectedRoute>} />
            <Route path="/sosmed" element={<ProtectedRoute><Sosmed /></ProtectedRoute>} />
            <Route path="/jarak-tempuh" element={<ProtectedRoute><Mileage /></ProtectedRoute>} />
            <Route path="/whatsapp" element={<ProtectedRoute><WhatsAppInbox /></ProtectedRoute>} />
            <Route path="/whatsapp/shortcuts" element={<ProtectedRoute><WaShortcuts /></ProtectedRoute>} />
            <Route path="/settings/ai-agent" element={<ProtectedRoute><WaAiAgent /></ProtectedRoute>} />
            <Route path="/pesan" element={<ProtectedRoute><Pesan /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          </Routes>
          <Toaster position="top-right" richColors closeButton />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
